import { CommonModule } from '@angular/common';
import {
  Component,
  HostBinding,
  HostListener,
  InputSignal,
  OnInit,
  WritableSignal,
  inject,
  input,
  signal,
} from '@angular/core';
import { WidgetsService } from '@app/core';
import { HydrationStrategyEnum } from '@app/core/enums/hydrate-and-defer-type.enum';
import { BaseWidget } from '@app/widgets/base-widget/base-widget';
@Component({
  selector: 'view-container',
  templateUrl: './view-container.component.html',
  styleUrl: './view-container.component.scss',
  standalone: true,
  imports: [CommonModule],
})
export class ViewContainerComponent extends BaseWidget implements OnInit {
  parentId: InputSignal<number> = input();
  public readonly allChildData = input.required<any[]>();
  public readonly allSlotsData = input.required<any[]>();
  public readonly childArrangement = input.required<'ADJACENT' | 'STACK'>();
  public readonly layoutParams = input.required<any>();
  public readonly containerStyle = input.required<any>();
  public readonly autoSuggestMenuData = input<any>();
  public readonly ngClass: InputSignal<any> = input();
  public readonly ngStyle: InputSignal<any> = input();
  public readonly actionEvent: InputSignal<Function> = input();

  @HostBinding('class') private readonly _componentClasses = this.ngClass();
  @HostBinding('style') private readonly _componentStyles = this.ngStyle();

  public readonly widgetsService = inject(WidgetsService);
  public readonly dynamicSlots = input(new Map<string, any>());

  HydrationAndDeferType = HydrationStrategyEnum

  constructor() {
    super();
  }

  ngOnInit() {}

  getRequiredDataforLogical(id: number) {
    const allChildSlotsData = this.allSlotsData().filter((slot: any) => {
      return slot.parentId === id;
    });

    return allChildSlotsData;
  }

  //variable to bind the onActionCall method and pass to child as input, not as output to emit
  actionInput = this.onActionCall.bind(this);

  renderWidget(slot: any, actionInput: any, autoSuggestSlots: any, userContextDto: any, inputUserSession: any, actionResponseContext: any): any {
    return {
      ngClass: this.widgetsService.cssClassMap.get(slot.id),
      ngStyle: this.widgetsService.cssStylesMap.get(slot.id),
      slot: slot,
      actionEvent: actionInput,
      autoSuggestSlots: autoSuggestSlots,
      userContextDto: userContextDto,
      inputUserSession: inputUserSession,
      actionResponseContext: actionResponseContext,
    };
  }

  onActionCall({ actionData }) {
    this.actionEvent()({ actionData });
  }
}
